export const patternDigitAfterComma = /^\d+(\.\d{0,2})?$/;
